import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Feedback {
  rating: number;
  feedback?: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private readonly apiUrl = `${environment.apiBaseUrl}/api/nps`;

  constructor(private readonly http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    // O interceptor Autenticacao vai adicionar automaticamente o token
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  submitFeedback(feedback: Feedback): Observable<any> {
    return this.http.post(this.apiUrl, feedback, {
      headers: this.getHeaders()
    });
  }

  getFeedbackHistory(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>(this.apiUrl, {
      headers: this.getHeaders()
    });
  }

  checkAvailability(): Observable<any> {
    return this.http.get(`${this.apiUrl}/disponibilidade`, {
      headers: this.getHeaders()
    });
  }
}



